/**
 * @generated SignedSource<<9cfeff55e4c10d9db7462341e8266653>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ProductHomeRelay$data = {
  readonly jira: {
    readonly issueByKey?: {
      readonly projectField: {
        readonly project: {
          readonly projectType: JiraProjectType | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly jiraProjectByKey?: {
      readonly projectType: JiraProjectType | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ProductHomeRelay";
};
export type ProductHomeRelay$key = {
  readonly " $data"?: ProductHomeRelay$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductHomeRelay">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "projectType"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "issueKey"
    },
    {
      "kind": "RootArgument",
      "name": "projectKey"
    },
    {
      "kind": "RootArgument",
      "name": "shouldCheckProjectType"
    },
    {
      "kind": "RootArgument",
      "name": "shouldCheckProjectTypeForIssue"
    }
  ],
  "kind": "Fragment",
  "name": "ProductHomeRelay",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "shouldCheckProjectTypeForIssue",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "key",
                  "variableName": "issueKey"
                }
              ],
              "concreteType": "JiraIssue",
              "kind": "LinkedField",
              "name": "issueByKey",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraProjectField",
                  "kind": "LinkedField",
                  "name": "projectField",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraProject",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": (v1/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "condition": "shouldCheckProjectType",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "key",
                  "variableName": "projectKey"
                }
              ],
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjectByKey",
              "plural": false,
              "selections": (v1/*: any*/)
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "a91db417f54284e616e6dc852d07c01c";

export default node;
